import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import AdminRoutes from '../../routes/AdminRoutes';
import './styles/adminpanel.css';

const links = [
  { to: '/home', label: 'Home'},
  { to: '/admin/parametros', label: 'Parametros' },
  { to: '/admin/area', label: 'Area' },
  { to: '/admin/categoria', label: 'Categoria' },
  { to: '/admin/rol', label: 'Rol' },
  { to: '/admin/tareas-area', label: 'Tareas del Área' },
  { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
  { to: '/admin/estadisticas', label: 'Estadísticas' },
  { to: '/auth/register', label: 'Crear Usuario' },
  { to: '/admin/administrar-usuarios', label: 'Administrar Usuarios' }
];

const TITLES = {
  '/admin/parametros': 'Pagina Parametros',
  '/admin/area': 'Pagina Area',
  '/admin/categoria': 'Pagina Categoria',
  '/admin/rol': 'Pagina Rol',
  '/admin/tareas-area': 'Tareas del Área',
  '/admin/estadisticas': 'Dashboard de Estadísticas',
  '/admin/administrar-usuarios': 'Administrar Usuarios'
};

const AdminPanel = () => {
  const location = useLocation();
  const title = TITLES[location.pathname] || 'Pagina';

  const handleLogout = () => {
    // Lógica de cierre de sesión aquí
    alert('Sesión cerrada');
  };

  return (
    <div className="admin-layout">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="admin-content">
        <h2>{title}</h2>
        <AdminRoutes />
      </main>
    </div>
  );
};

export default AdminPanel;
